import {useState} from 'react';
import {ArrToggle} from '../../../components/common/arr-toggle/ArrToggle';

const ToggleDemo = () => {
  const [isActive, setIsActive] = useState(false);

  const handleToggleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setIsActive(checked);
    onIsActiveChange?.(checked);
  };
  return (
    <>
      <br />
      <ArrToggle
        disabled={false}
        checked={isActive}
        toggleSize="large"
        onChange={handleToggleChange}
        dataTestId="demo-large-toggle"
      />
      <br />
      <ArrToggle
        disabled={false}
        checked={isActive}
        toggleSize="medium"
        onChange={handleToggleChange}
        dataTestId="demo-medium-toggle"
      />
      <br />
      <ArrToggle
        disabled={false}
        checked={isActive}
        toggleSize="small"
        onChange={handleToggleChange}
        dataTestId="demo-small-toggle"
      />
      <br />
      <ArrToggle
        disabled={false}
        checked={isActive}
        toggleSize="xs"
        onChange={handleToggleChange}
        dataTestId="demo-xs-toggle"
      />
      <br />
      <ArrToggle
        disabled={true}
        checked={isActive}
        toggleSize="large"
        onChange={handleToggleChange}
        dataTestId="demo-large-active-toggle"
      />
      <br />
    </>
  );
};

export default ToggleDemo;
